export const PARCEL_EMAIL_EDITOR_SRC = 'https://parcel.io/embed/cio/email';
export const PARCEL_IN_APP_EDITOR_SRC = 'https://parcel.io/embed/cio/in-app';
export const PARCEL_IN_APP_EDITOR_SRC_DEV = 'https://parcel.io/embed/cio/in-app/development';

export const LOAD_TIMEOUT_MS = 30000;

export enum ParcelState {
  Init = 'INIT',
  Ready = 'READY',
  Interactive = 'INTERACTIVE',
  Error = 'ERROR',
}

export interface ParcelBroadcastEvent {
  event: string;
  data?: { message?: string; type: string };
}
